// canvas methods
export const chartSystemMethods = {
  methods: {
    createLine(moveTo, lineTo, fillStyle, strokeStyle, lineWidth = 1, shadow) {
      this.ctx.save();
      this.ctx.beginPath();
      if (fillStyle) { this.ctx.fillStyle = fillStyle; }
      if (strokeStyle) { this.ctx.strokeStyle = strokeStyle; }
      if (shadow) { for (let s in shadow) { this.ctx[s] = shadow[s]; } }
      this.ctx.lineWidth = lineWidth;
      this.ctx.moveTo(moveTo.x, moveTo.y);
      this.ctx.lineTo(lineTo.x, lineTo.y);
      this.ctx.stroke();
      this.ctx.fill();
      this.ctx.closePath();
      this.ctx.restore();
    },
    createText(x, y, text, fillStyle, font, textAlign = 'center', textBaseline = 'alphabetic') {
      this.ctx.save();
      this.ctx.beginPath();
      this.ctx.fillStyle = fillStyle;
      this.ctx.font = font;
      this.ctx.textAlign = textAlign;
      this.ctx.textBaseline = textBaseline;
      this.ctx.fillText(text, x, y);
      this.ctx.closePath();
      this.ctx.restore();
    },
    createRect(x, y, w, h, strokeStyle, fillStyle) {
      this.ctx.save();
      this.ctx.beginPath();
      this.ctx.fillStyle = fillStyle;
      this.ctx.strokeStyle = strokeStyle;
      this.ctx.rect(x, y, w, h);
      this.ctx.fill();
      this.ctx.restore();
    },
    createCustomBoxShadow(x, y, w, h, color) {
      this.ctx.save();
      this.ctx.beginPath();

      let gradient = this.ctx.createLinearGradient(x, y, x + w, y);
      gradient.addColorStop(0, 'rgba(0, 0, 0, 0)');
      gradient.addColorStop(1, color);
      this.ctx.fillStyle = gradient;

      this.ctx.rect(x, y, w, h);
      this.ctx.fill();
      this.ctx.restore();
    },
    drawBazierCurve(currentX, currentY, nextX, nextY) {
      let xMid = (currentX + nextX) / 2;
      let yMid = (currentY + nextY) / 2;
      let cpX1 = (xMid + currentX) / 2;
      let cpX2 = (xMid + nextX) / 2;
      this.ctx.quadraticCurveTo(cpX1, currentY, xMid, yMid);
      this.ctx.quadraticCurveTo(cpX2, nextY, nextX, nextY);
    },
    createController(x, y, w, h, strokeStyle, fillStyle) {
      this.ctx.save();
      this.ctx.beginPath();
      this.ctx.fillStyle = fillStyle;
      this.ctx.strokeStyle = strokeStyle;

      this.ctx.lineWidth = 6;
      this.ctx.moveTo(x, y);
      this.ctx.lineTo(x, y + h);
      this.ctx.stroke();

      this.ctx.beginPath();
      this.ctx.lineWidth = 1;
      this.ctx.moveTo(x, y + h);
      this.ctx.lineTo(x + w, y + h);
      this.ctx.stroke();

      this.ctx.beginPath();
      this.ctx.lineWidth = 6;
      this.ctx.moveTo(x + w, y + h);
      this.ctx.lineTo(x + w, y);
      this.ctx.stroke();

      this.ctx.beginPath();
      this.ctx.lineWidth = 1;
      this.ctx.moveTo(x + w, y);
      this.ctx.lineTo(x, y);
      this.ctx.stroke();

      this.ctx.fill();
      this.ctx.closePath();
      this.ctx.restore();
    },
    createRoundedRect(x, y, width, height, radius, strokeStyle, fillStyle) {
      this.ctx.save();
      this.ctx.beginPath();
      if (strokeStyle) { this.ctx.strokeStyle = strokeStyle; }
      if (fillStyle) { this.ctx.fillStyle = fillStyle; }
      this.ctx.moveTo(x + radius, y);
      this.ctx.arcTo(x + width, y, x + width, y + radius, radius);
      this.ctx.arcTo(x + width, y + height, x + width - radius, y + height, radius);
      this.ctx.arcTo(x, y + height, x, y + height - radius, radius);
      this.ctx.arcTo(x, y, x + radius, y, radius);
      this.ctx.fill();
      this.ctx.stroke();
      this.ctx.closePath();
      this.ctx.restore();
    },
    createArc(x, y, radius, fillStyle, lineWidth) {
      this.ctx.save();
      this.ctx.beginPath();
      this.ctx.fillStyle = fillStyle;
      this.ctx.lineWidth = lineWidth;
      this.ctx.arc(x, y, radius, 0, 2 * Math.PI);
      this.ctx.fill();
      this.ctx.closePath();
      this.ctx.restore();
    },
    createHint(center, y, font, colors, chartData) {
      let width = 174;
      // eslint-disable-next-line no-mixed-operators
      let start = center - width / 2;
      let [topBottom, leftRight, radius] = [12, 14, 6];
      this.createRoundedRect(start, y, width, 24, 10, colors.controllerBg, colors.controllerBg);
      this.createArc(start + leftRight, y + topBottom, radius, chartData[0].colorArc);
      this.createText(start + leftRight + 35, y + topBottom, this.$t('common.balance'), colors.text, font, 'center', 'middle');
      this.createArc(start + leftRight + 90, y + topBottom, radius, chartData[1].colorArc);
      this.createText(start + leftRight + 125, y + topBottom, this.$t('common.turnover'), colors.text, font, 'center', 'middle');
    },
    formatDate(value) {
      // console.log(value)
      return this.$date(value, 'DD/MM');
    },
    getChartFormatAmount(value, ident) {
      if (value === 0) {
        return '';
      }
      const res = parseFloat(value).toFixed(1);
      return res % 1 === 0 ? Math.round(value) + ident : res + ident;
    },

    getChartAmount(floatAmount) {
      const value = Math.abs(Number(floatAmount));
      switch (true) {
        case value === 0:
          return 0;
        case value < 10 ** 3:
          return value;
        case value < 10 ** 6:
          return value / (10 ** 3);
        case value < 10 ** 9:
          return value / (10 ** 6);
        default:
          return value / (10 ** 9);
      }
    },
    getChartAmountIdent(floatAmount) {
      const value = Math.abs(Number(floatAmount));
      switch (true) {
        case value === 0:
          return '';
        case value < 10**3:
          return ` ${this.$t('common.rub')}`;
        case value < 10**6:
          return ` ${this.$t('common.k')}`;
        case value < 10**9:
          return ` ${this.$t('common.mln')}`;
        default:
          return ` ${this.$t('common.mlrd')}`;
      }
    },

    pacanFormatAmount(amount, currency) {
      const value = Math.ceil(amount / 10 ** (currency.significant_zeros ?? 2));
      return this.getChartFormatAmount(this.getChartAmount(value), this.getChartAmountIdent(value));
    },

    checkDirectionZoom(y) {
      let direction = '';
      if (y < 0) { direction = 'up'; }
      else if (y > 0) { direction = 'down'; }
      return direction;
    },
    checkDirectionPinch(x) {
      let direction = '';
      if (x < this._oldPinch) { direction = 'down'; }
      else if (x > this._oldPinch) { direction = 'up'; }
      this._oldPinch = x;
      return direction;
    },
    isOver(mouseX, mouseY, x, y, w, h) {
      return mouseX >= x && mouseX <= x + w && mouseY >= y && mouseY <= y + h;
    },
  },
};
